import { Parser } from 'marked';
import { MarkedOptions, MarkedRenderer } from 'ngx-markdown';

export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();
  renderer.link = ({ href, title, tokens }) => {
    const text = Parser.parseInline(tokens);
    const icon =
      '<span aria-hidden="true" class="marked-link rds-icon"><img src="assets/external.svg" width="24" height="auto" alt="external-icon" /></span>';
    return `<a class="marked-link rds-link rds-link--primary rds-link-s" href="${href}" target="_blank" ${title ? `title="${title}"` : ''}>${text}${!href.toLowerCase().startsWith('mailto:') ? icon : ''}</a>`;
  };
  return {
    renderer,
    gfm: true,
    breaks: false,
    pedantic: false,
  };
}
